export default "__VITE_ASSET__quN6Ebmr__"